import { useNavigate } from "react-router-dom";
import { CreditCard, ArrowLeftRight, ChevronRight, Inbox } from "lucide-react";
import { SubHeader, StatusBadge, EmptyState } from "@/components/Brand";
import { useApi } from "@/lib/api";
import { rp, fmtDateTime, KIND_LABEL, METHOD_LABEL, fmtAcc } from "@/lib/format";

export const RequestItem = ({ r }) => (
  <div className="bg-white border border-slate-200 rounded-2xl p-4" data-testid={`request-item-${r.req_id}`}>
    <div className="flex justify-between items-start gap-2">
      <div>
        <div className="font-semibold text-sm text-slate-900">{KIND_LABEL[r.kind]}</div>
        <div className="text-[11px] text-slate-500">{fmtDateTime(r.created_at)} • {METHOD_LABEL[r.method]}</div>
      </div>
      <StatusBadge status={r.status} />
    </div>
    <div className="flex justify-between items-end mt-2">
      <div className="text-xs text-slate-600">
        {r.kind === "transfer_bank" && `${r.bank_name} • ${r.account_no} • ${r.recipient_name}`}
        {r.kind === "transfer_member" && `${r.recipient_name} (${r.target_account_no ? fmtAcc(r.target_account_no) : r.target_member_no})`}
        {r.kind === "setoran" && `Simpanan ${r.savings_type}`}
      </div>
      <div className="font-bold text-slate-900">{rp(r.amount)}</div>
    </div>
    {r.admin_note && <div className="text-xs text-slate-700 mt-2 bg-slate-50 rounded-lg p-2">Catatan admin: {r.admin_note}</div>}
  </div>
);

export default function Transactions() {
  const navigate = useNavigate();
  const { data } = useApi("/requests");
  const items = [
    { icon: CreditCard, t: "Pembayaran", d: "Angsuran, setoran simpanan, biaya administrasi", to: "/app/transaksi/bayar", id: "payments" },
    { icon: ArrowLeftRight, t: "Transfer Online", d: "Ke rekening bank atau sesama anggota", to: "/app/transaksi/transfer", id: "transfer" },
  ];
  return (
    <div>
      <SubHeader title="Transaksi" />
      <div className="px-5 space-y-3">
        {items.map(({ icon: Icon, t, d, to, id }) => (
          <button key={id} onClick={() => navigate(to)} data-testid={`transactions-menu-${id}`}
            className="w-full flex items-center gap-4 bg-white border border-slate-200 rounded-2xl p-4 text-left hover:shadow-md transition-shadow">
            <div className="h-11 w-11 rounded-xl bg-red-50 flex items-center justify-center"><Icon className="h-5 w-5 text-red-600" /></div>
            <div className="flex-1"><div className="font-semibold text-sm">{t}</div><div className="text-xs text-slate-500">{d}</div></div>
            <ChevronRight className="h-5 w-5 text-slate-400" />
          </button>
        ))}
        <h2 className="font-bold text-slate-900 pt-3">Riwayat Permintaan</h2>
        {data?.length === 0 && <EmptyState testid="requests-empty" icon={Inbox} title="Belum ada transaksi" text="Pembayaran dan transfer Anda akan tampil di sini." />}
        <div className="space-y-2" data-testid="requests-list">
          {data?.map((r) => <RequestItem key={r.req_id} r={r} />)}
        </div>
      </div>
    </div>
  );
}
